import {
    setNavOpen,
} from "../helpers/commit_helpers";

export default function mapOverlaySelected(sm) {
    setNavOpen(sm, false);
}